import React, { useEffect } from 'react';

const TermsPage = () => {
  useEffect(() => {
    if (!document.getElementById('fa-stylesheet')) {
      const linkFa = document.createElement('link');
      linkFa.id = 'fa-stylesheet';
      linkFa.rel = 'stylesheet';
      linkFa.href =
        'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css';
      document.head.appendChild(linkFa);
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0F19] text-gray-200 font-sans py-12 px-6">
      <div className="max-w-4xl mx-auto bg-[#111827]/70 backdrop-blur-md p-8 md:p-12 rounded-[32px] border border-gray-800 shadow-2xl">

        <div className="inline-block px-3 py-1 bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 font-bold uppercase tracking-widest text-xs rounded-md mb-4">
          Legal Document
        </div>

        <h1 className="text-3xl md:text-4xl font-black text-white mb-2">
          Terms and Conditions
        </h1>

        <p className="text-sm text-gray-500 mb-6">
          Last Updated: June 2026
        </p>

        <div className="mb-8 p-4 rounded-xl bg-indigo-500/10 border border-indigo-500/20">
          <p className="text-sm text-gray-300 leading-relaxed">
            <strong className="text-white">VP Cafe Connect</strong> is the official
            digital services platform operated by
            <strong className="text-white"> VP Cafe</strong> and accessible
            through our official website
            <strong className="text-white"> vpcafe.in</strong>.
          </p>
        </div>

        <div className="space-y-8 text-gray-400 leading-relaxed text-sm md:text-base">

          <section>
            <h2 className="text-xl font-bold text-white mb-3">
              1. Acceptance of Terms
            </h2>
            <p>
              By accessing or using VP Cafe Connect, you agree to be bound by
              these Terms and Conditions.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">
              2. Description of Services
            </h2>
            <p>
              VP Cafe Connect provides digital assistance services including
              government applications, document services, online form
              submissions, ID-related services, and other digital support.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">
              3. User Responsibilities
            </h2>
            <p>
              Users are responsible for ensuring that all information
              provided is accurate and complete.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">
              4. Payments and Refunds
            </h2>
            <p>
              Government fees and service charges may be non-refundable
              once processing has started.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">
              5. Contact Information
            </h2>

            <div className="space-y-2">
              <p>
                <strong className="text-white">Platform:</strong> VP Cafe Connect
              </p>

              <p>
                <strong className="text-white">Operator:</strong> VP Cafe
              </p>

              <p>
                <strong className="text-white">Website:</strong> vpcafe.in
              </p>

              <p>
                <strong className="text-white">Email:</strong> admin@vpconnect.in
              </p>
            </div>
          </section>

        </div>

        <div className="mt-12 pt-8 border-t border-gray-800">
          <a
            href="/"
            className="inline-flex items-center text-indigo-400 hover:text-indigo-300 transition font-medium"
          >
            <i className="fa-solid fa-arrow-left mr-2"></i>
            Back to Home
          </a>
        </div>

      </div>
    </div>
  );
};

export default TermsPage;